setTimeout(function () {
    // Register GSAP Plugins
    gsap.registerPlugin(ScrollTrigger);

    var kaLarge = window.matchMedia('(min-width: 800px)');
    var kaSmall = window.matchMedia('(max-width: 799px)');
    var e = ["#AEC4ED", "#AEE0BC", "#E8D2EB", "#FFC1CE", "#BFA5D2", "#CFF0F5", "#FCD7D1", "#554FF9", "#FF4901", "#ACDE53", "#FE54C5"];
    var n = $("#app").css("background-color");
    var r = $(".testimonial-item:not(.default-main)"); // Testimonial items
    var i = $(".testimonial-wrapper"); // Wrapper element
    var o = 0; // Keeps track of the current testimonial index
    var s = []; // Stores dynamically created testimonials
    var maxTestimonials = 7; // Maximum number of dynamic testimonials to display

    // Validate if required elements are present
    if (!r.length || !i.length) {
        console.error("Testimonial items or wrapper not found");
        return;
    }

    // Handle Click on Wrapper for Positioning and Cloning
    i.on("click", function (event) {
        // Prevent running the function if the click originates from the testimonial-footer
        if ($(event.target).closest(".testimonial-footer").length) {
            console.log("Click on testimonial-footer; ignoring testimonial-item function.");
            return;
        }

        event.preventDefault();

        var cursorX = event.pageX; // Cursor X position
        var cursorY = event.pageY; // Cursor Y position

        // Get dimensions and offsets of the wrapper
        var wrapperOffset = i.offset();
        var wrapperWidth = i.width();
        var wrapperHeight = i.height();

        // Clone the current testimonial item
        var u = r.eq(o).clone();

        // Define testimonial dimensions
        var testimonialWidth = 369; // Fixed width of testimonial
        var testimonialHeight = u.outerHeight(); // Dynamically get height

        // Calculate position to center the testimonial at the cursor
        var leftPosition = cursorX - testimonialWidth / 2;
        var topPosition = cursorY - testimonialHeight / 2;
        var bottomPosition = null;

        // Check if click is near the bottom of the wrapper (within a certain threshold)
        var bottomThreshold = 20; // Set a threshold distance from the bottom edge

        // Mobile behavior: set top to 0
        if (kaSmall.matches) {
            topPosition = wrapperOffset.top; // Set to top of the wrapper
        } else {
            // Check if the click is near the bottom edge and adjust positioning accordingly
            if (cursorY > wrapperOffset.top + wrapperHeight - bottomThreshold) {
                bottomPosition = 100; // Snap to the bottom edge
            } else {
                // Otherwise, constrain the position within the wrapper
                topPosition = Math.max(
                    wrapperOffset.top,
                    Math.min(topPosition, wrapperOffset.top + wrapperHeight - testimonialHeight)
                );
            }
        }

        // Constrain the left position to the wrapper width bounds
        leftPosition = Math.max(
            wrapperOffset.left,
            Math.min(leftPosition, wrapperOffset.left + wrapperWidth - testimonialWidth)
        );

        // Set a random background color (different from the app background)
        var backgroundColor = e[Math.floor(Math.random() * e.length)];
        if (backgroundColor === n) {
            backgroundColor = "white";
        }

        // Apply styles to the cloned testimonial
        var testimonialStyles = {
            position: "absolute",
            left: leftPosition - wrapperOffset.left + "px", // Offset relative to the wrapper
            transform: "rotate(" + (16 * Math.random() - 8) + "deg)", // Random slight rotation
            "background-color": backgroundColor,
            "z-index": 1000, // Ensures it's on top
        };

        // Apply bottom CSS when near the bottom edge
        if (bottomPosition !== null) {
            testimonialStyles.bottom = 0; // Set bottom to 0 if near the bottom edge
        } else {
            // Apply top CSS for positioning
            testimonialStyles.top = topPosition - wrapperOffset.top + "px";
        }

        u.css(testimonialStyles);
        u.addClass("dynamic-testimonial");

        // Append the testimonial to the wrapper
        i.append(u);

        // Add the cloned testimonial to the array
        s.push(u);
        // GSAP animations for the testimonial
        gsap.from(u, { scale: 0.92, duration: 0.6, ease: "power1.out" });
        gsap.from(u, { autoAlpha: 0, duration: 0.6 });
        // Remove old testimonials if limit is exceeded
        if (s.length > maxTestimonials) {
            var oldTestimonial = s.shift(); // Remove the first item in the array
            gsap.timeline({
                onComplete: function () {
                    oldTestimonial.remove(); // Remove from DOM
                },
            }).to(oldTestimonial, {
                autoAlpha: 0, // Fade out
                scale: 0.9,   // Shrink slightly
                duration: 0.3, // Faster removal animation
            });
        }

        // Update the testimonial index
        o = (o + 1) % r.length;
    });

    // ScrollTrigger for Footer Rotation
    const footer = $("footer");
    if (footer.length) {
        gsap.to($(".svg-footer svg"), {
            rotation: 120,
            ease: "none",
            scrollTrigger: {
                trigger: footer,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
            },
        });
    } else {
        console.warn("Footer element not found for ScrollTrigger.");
    }
}, 400);
